export const IMAGE_HOST = '//images.ctfassets.net';
export const VIDEO_HOST = '//videos.ctfassets.net';
export const BASE_PATH = '9uo1qvvet3xa';
export const UPLOAD_FOLDER = 'cms';

export const GEO_AVAILABILITY = {
  SHOW: 'SHOW',
  HIDE: 'HIDE',
  LATER: 'LATER',
};
